
class ResultMessage {
    constructor() {
        this.status = 200;
        this.result = 0;
        this.title = '';
        this.message = '';
        this.payload = {};        
        // this.jwt = '';    
    }

    buildSuccessMessage(response) {        
        this.status = response.status;
        this.result = response.data.result;
        this.title = response.data.title;
        this.message = response.data.message;
        this.payload = response.data.payLoad;
        // if(response.headers.authorization != 'undefined') {
        //     this.jwt = response.headers.authorization;
        // }
    }

    buildErrorMessage(error) {
        try {
            this.status =  error.response.data.status;
            this.message = error.response.data.message;
            if(this.status == 404) {
                this.message = '잘못된 요청입니다.';
            }
        } catch(e) {
            if (error.response) {
                // The request was made and the server responded with a status result
                // that falls out of the range of 2xx
                this.status = error.response.data.status;
                if(this.status == 404) {
                    this.message = '존재하지 않는 url 입니다.';
                } else if (this.status == 500){
                    this.message = '처리중 문제가 발생하였습니다.\n관리자에게 문의 바랍니다.';
                } else if (this.status == 401) {
                    this.message = '로그아웃 되었습니다.';
                } else {
                    this.message = '서버 점검 중 입니다.\n 잠시후 다시 시도해 주세요.';
                }                                
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                
                this.status = 408;                
                this.result = 408;
                this.message = '요청시간이 초과하였습니다.\n 다시 요청 바랍니다.';                                
            } else {
                // Something happened in setting up the request that triggered an Error
                
                this.message = 'error message : ' + error.message;
                
            }
        }             
    }
}

export default ResultMessage;


// WEBPACK FOOTER //
// ./src/data/resultMessage.js